import routes from '../../config/routes';

type PortalRoute = {
  path?: string;
  name?: string;
  hideInMenu?: boolean;
  routes?: PortalRoute[];
};

export type CenterKey =
  | 'employee'
  | 'attendance'
  | 'payroll'
  | 'social-insurance'
  | 'performance';

export const CENTER_ROOTS: Record<CenterKey, string> = {
  employee: '/me',
  attendance: '/attendance-center',
  payroll: '/payroll-center',
  'social-insurance': '/social-insurance-center',
  performance: '/performance-center',
};

export const NAVIGATION_ROOTS = { ...CENTER_ROOTS, settings: '/settings' };

export function getSettingsPath(access: Record<string, boolean | undefined>) {
  return access.permission
    ? '/settings/permissions'
    : access.modelSettings
      ? '/settings/model-settings'
      : undefined;
}

export function getNavigationForPath(pathname: string): CenterKey | 'settings' {
  const path = pathname.split(/[?#]/, 1)[0];
  return path === '/settings' || path.startsWith('/settings/')
    ? 'settings'
    : getCenterForPath(path);
}

export function getCenterForPath(pathname: string): CenterKey {
  const match = (Object.entries(CENTER_ROOTS) as [CenterKey, string][])
    .sort(([, left], [, right]) => right.length - left.length)
    .find(([, root]) => pathname === root || pathname.startsWith(`${root}/`));
  return match?.[0] || 'employee';
}

const MENU_PATHS = (routes as PortalRoute[])
  .filter(
    (route) =>
      route.path && Object.values(NAVIGATION_ROOTS).includes(route.path),
  )
  .flatMap((route) => route.routes || [])
  .filter((route) => route.name && !route.hideInMenu)
  .map((route) => route.path)
  .filter((path): path is string => Boolean(path));

export function getSplitMenuSelectedKeys(pathname: string): string[] {
  const cleanPathname = pathname.split(/[?#]/, 1)[0] || '/me';
  const centerRoot = NAVIGATION_ROOTS[getNavigationForPath(cleanPathname)];
  const currentMenuPath = MENU_PATHS.filter(
    (path) => cleanPathname === path || cleanPathname.startsWith(`${path}/`),
  ).sort((left, right) => right.length - left.length)[0];

  return [centerRoot, currentMenuPath || centerRoot];
}
